<div class="wrapper">
	@if (venue) {
		<div class="venue">
			@if (venue) {
				<h3>{{ venue.name }}</h3>
			}
			<div class="change-location-block">
				<ion-icon class="location" src="../../../assets/topgolf/location.svg"></ion-icon>
				<p (click)="showPopoverToBack($event)" class="change-location">{{ 'menu_page.change_location' | translate }}</p>
			</div>
		</div>
	}
	<ion-icon (click)="onBack()" class="logo" src="../../../assets/topgolf/header_logo.svg"></ion-icon>
	<div class="action-block">
		@if (order && showGoToBasketBtn && order?.orderedArticles?.length > 0) {
			<ion-button (click)="showBasket.emit()" class="show-basket">
				<ion-icon src="../../../assets/topgolf/Orders_white.svg"></ion-icon>
				<h4>{{ formattedPrice }}</h4>
			</ion-button>
		}
		<app-burger-btn></app-burger-btn>
	</div>
</div>
